export default "__VITE_PUBLIC_ASSET__f61d1cbf__"